export default __webpack_public_path__ + "media/icons/shopify-119cee32.png";